$(function() {
  $('.vol').click(function(){
    if ($(this).hasClass('fa-volume-xmark')) {
      $('.home-vid video').prop('muted', false);
    }
    if ($(this).hasClass('fa-volume-high')) {
      $('.home-vid video').prop('muted', true);
    }
    $(this).toggleClass('fa-volume-high');
    $(this).toggleClass('fa-volume-xmark');
  });

  $('.footer-block__details-content li').each(function() {
    console.log($(this).find('a').text());
    if ($(this).find('a').text().trim() == "Instagram") {
      console.log("IG");
      $(this).find('a').attr('target', '_blank');
    }
  });
    
  // $('.index-page .home-page-blocks').addClass('page-width--narrow');

  if (window.location.href.indexOf('/collections/') > -1) {
    console.log('collection page');
    $('.product-card-slider').each(function() {

      var the_rrwi = rRWI(2000, 10000, 1000);
      
      $(this).slick({
        autoplay: false,
        autoplaySpeed: the_rrwi,
        speed: 250,
        infinite: true,
        prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
        nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>'
      });
      
    });

    $('.product-card-desk').hover(function() {
      $(this).find('.onefer').fadeOut(300);
      $(this).find('.twofer').fadeIn(300);
    }, function() {
      $(this).find('.onefer').fadeIn(300);
      $(this).find('.twofer').fadeOut(300);
    });
    
  }

function rRWI(min, max, inc) {
  min = min || 0;
  inc = inc || 1;
  if(!max) { return new Error('need to define a max');}
  return Math.floor(Math.random() * (max - min) / inc) * inc + min;
}
  
});


$(window).on('load', function() {
  // setTimeout(function() {
      $('.home-page-blocks .grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      gutter: 130,
      horizontalOrder: true
    });
  // }, 2000);
});

// Mobile Gallery Progress Indicator
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.main-product slider-component');
  if (!slider) return;

  const counter = slider.querySelector('.slider-counter--current');
  const dots = slider.querySelectorAll('.gallery-progress-dot');

  if (!counter || dots.length === 0) return;

  // Update dots based on current slide
  function updateProgressDots() {
    const currentSlide = parseInt(counter.textContent) || 1;
    dots.forEach(function(dot, index) {
      dot.classList.toggle('active', index + 1 === currentSlide);
    });
  }

  // Observe changes to the slider counter
  const observer = new MutationObserver(updateProgressDots);
  observer.observe(counter, { childList: true, characterData: true, subtree: true });

  // Initial update
  updateProgressDots();
});